import React, { useContext, useEffect, useRef, useState } from 'react';
import TableTwoBody from "../../CommonComponent/BootstrapTable2Body/TableTwoBody";
import { AgentWalletHistoryContext } from "../../AgentWalletHistoryComponent/AgentWalletHistoryComponent";
import DateFormat from "../../../Utilities/DateFormat";
import NumberSeparator from "../../../Utilities/NumberSeparator";
import { AgentCollectionHistoryContext } from "../AgentCollectionHistoryCoponent";
import { Table } from 'react-bootstrap';
import { FaPrint } from "react-icons/fa6";
import { useDispatch } from 'react-redux';
import { memberCollectionAction, singleCollectionHistoryAction } from '../../../Redux/Action/MemberAction';
import { useNavigate } from 'react-router-dom';

function CollectionHistoryTable(props) {
    const dispatch = useDispatch()
    const btnRef = useRef()
    const navigate = useNavigate();
    // state
    const [singleCollectionHistory, setSingleCollectionHistory] = useState({})

    const collectionId = singleCollectionHistory?.id || "";

    // Context
    const {
        filteredAgentCollectionHistory,
        organization
    } = useContext(AgentCollectionHistoryContext)

    // states
    const [totaCollectionAmount, setTotalCollectionAmount] = useState(0)

    // making total collection amount
    useEffect(() => {
        let totalCollection = 0
        filteredAgentCollectionHistory.map(singleWallet => {
            totalCollection += singleWallet.collection_amount
        })
        setTotalCollectionAmount(totalCollection)
    }, [filteredAgentCollectionHistory])



    const columns = [{
        dataField: 'id',
        text: 'SL',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '50px',
            };
        },
        formatter: (cell, row, rowIndex) => {
            return <>
                {rowIndex + 1}
            </>
        }
    }, {
        dataField: 'member.member_name',
        text: 'Donor Name',
        sort: true

    }, {
        dataField: 'member.mobile',
        text: 'Phone',
        sort: true

    }, {
        dataField: 'member.village',
        text: 'Village',
        sort: true

    }, {
        dataField: 'member.police_station',
        text: 'Police Station',
        sort: true

    }, {
        dataField: 'member.cnfg_organization',
        text: 'Organization',
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>
                {row.cnfg_organization?.organization_name || '-'}
            </>
        }

    }, {
        dataField: 'purpose',
        text: 'Purpose',
        sort: true,
        formatter: (cell, row) => {
            return <>
                {cell == "Other" ? row.goods : cell}
            </>;
        }


    }, {
        dataField: '',
        text: 'Collected By',
        sort: false,
        formatter: (cell, row, rowIndex) => {
            return <>
                {`${row.user?.full_name} I'D ${row.user?.id}`}
            </>
        }
    }, {
        dataField: 'createdAt',
        text: 'Date',
        sort: false,
        formatter: (cell, row, rowIndex) => {
            return <>
                {DateFormat.format(cell)}
            </>
        }
    }, {
        // dataField: 'member.collection_amount',
        text: 'Amount',
        sort: false,
        formatter: (cell, row, rowIndex) => {
            // console.log(row.collection_amount)
            return <>
                {NumberSeparator.format(row.collection_amount)}
            </>
        }

    },
    // {
    //     dataField: 'user.user_name',
    //     text: 'Collected By',
    //     sort: false
    // }, 
    {
        dataField: 'user',
        text: 'Action',
        sort: false,
        headerStyle: (colum, colIndex) => {
            return {
                width: '50px',
            };
        },
        formatter: ((cell, row) => {
            return <>
                {/*Change Password*/}
                <button title="Print" ref={btnRef}
                    className="btn btn-sm btn-success"
                    onClick={e => {
                        // data for update
                        navigate(`/print?id=${row.id}`);

                    }
                    }>
                    Print
                </button>




            </>
        })
    }
    ];
    return (
        <>
            {/* total collection table */}
            <Table bordered striped>
                <tbody>
                    <tr>
                        <td>Total Collection</td>
                        <td className=" text-end">{NumberSeparator.format(totaCollectionAmount)}</td>
                    </tr>
                </tbody>
            </Table>

            {/* collection history table */}
            <TableTwoBody
                products={filteredAgentCollectionHistory}
                columns={columns}
                isBorderd={true}
                is_pagination={false}
            />
        </>
    );
}

export default CollectionHistoryTable;